import './src/css/global.css';
import React from "react"
import { CartContextProvider } from './src/components/cart_context';

export const wrapRootElement = ({ element }) => 
  (
    <CartContextProvider>
      {element}
    </CartContextProvider>
  )
